import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorLayout from '../../components/error/ErrorLayout';

export default function ServerErrorPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <ErrorLayout
      code={t('errors.serverError.code')}
      title={t('errors.serverError.title')}
      message={
        <>
          {t('errors.serverError.message')}<br />
          {t('errors.serverError.messageSub')}
        </>
      }
      icon="settings"
    >
      <div className="error-actions">
        <button className="btn btn-primary" onClick={handleRetry}>
          {t('errors.serverError.retry')}
        </button>
        <Link to="/" className="btn btn-secondary">
          {t('errors.serverError.backHome')}
        </Link>
      </div>

      <div className="error-support">
        <p>
          {t('errors.serverError.support')}{' '}
          <a href="mailto:support@pilotleague.com">support@pilotleague.com</a>
        </p>
      </div>
    </ErrorLayout>
  );
}
